var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrewdriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 10.5L3.62132 17.3787C3.2235 17.7765 3 18.3161 3 18.8787C3 19.4413 3.2235 19.9808 3.62132 20.3787V20.3787C4.01915 20.7765 4.55871 21 5.12132 21C5.68393 21 6.2235 20.7765 6.62132 20.3787L13.5 13.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6292 3.03346L17.1768 3.85062C16.7684 3.98671 16.4929 4.36886 16.4929 4.79931V6.50782C16.4929 7.06011 16.9406 7.50782 17.4929 7.50782H19.2025C19.6331 7.50781 20.0153 7.23219 20.1513 6.82364L20.9674 4.37182C21.0271 4.19226 20.9804 3.99434 20.8466 3.86048L20.1409 3.1544C20.007 3.02041 19.8089 2.97359 19.6292 3.03346Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 12.0007L16.7857 7.21484",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10L14 14",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.24002 10.76L3.30002 7.82002C2.89999 7.41945 2.89999 6.77058 3.30002 6.37002L6.37002 3.30002C6.77058 2.89999 7.41945 2.89999 7.82002 3.30002L12.26 7.74002",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.26 11.7383L20.7 16.1783C21.1 16.5788 21.1 17.2277 20.7 17.6283L17.63 20.6983C17.2294 21.0983 16.5806 21.0983 16.18 20.6983L13.24 17.7583",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrewdriver);
export default __webpack_public_path__ + "static/media/screwdriver.7b1d6d8ad4cb6f37fb7605e96098f166.svg";
export { ForwardRef as ReactComponent };